import q_phase from "!!raw-loader!./exampleq-phase.md"   //eslint-disable-line import/no-webpack-loader-syntax
import q_searchp from "!!raw-loader!./exampleq-searchp.md"   //eslint-disable-line import/no-webpack-loader-syntax
import q_compiletimepos from "!!raw-loader!./exampleq-fixedpos.md"   //eslint-disable-line import/no-webpack-loader-syntax
import q_relink from "!!raw-loader!./exampleq-relink.md"   //eslint-disable-line import/no-webpack-loader-syntax
import q_libpathrelative from "!!raw-loader!./exampleq-libpathrelative.md"   //eslint-disable-line import/no-webpack-loader-syntax

import r_ldlibrarypath  from "!!raw-loader!./exampler-lidlibrarypath.md"   //eslint-disable-line import/no-webpack-loader-syntax
import r_relink_rpath   from "!!raw-loader!./exampler-relink-rpath.md"   //eslint-disable-line import/no-webpack-loader-syntax
import r_patchelf_rpath from "!!raw-loader!./exampler-patchelf-rpath.md"   //eslint-disable-line import/no-webpack-loader-syntax
import r_relink_origin from  "!!raw-loader!./exampler-relink-relative.md"   //eslint-disable-line import/no-webpack-loader-syntax

export const qset = [ { 'key': 'phase',
			'content': q_phase,
			'ans': ['runtime', 'compile-time'] },

		      {'key': 'q-searchcp',
		       'content': q_searchp,
		       'ans': ['yes', 'no'] },

		      {'key': 'q-libpathlinktime',
		       'content': q_compiletimepos,
		       'ans': ['yes', 'no'] },

		      {'key': 'q-libpathrelative',
		       'content': q_libpathrelative,
		       'ans': ['yes', 'no'] },		      

		      {'key': 'q-relink',
		       'content': q_relink,
		       'ans': ['yes', 'no'] },

		    ];


export const repairset = [ { 'key': 'r-ldlibrarypath',
			     'content': r_ldlibrarypath } ,

			   { 'key': 'r-relink-rpath',
			     'content': r_relink_rpath },

			   { 'key': 'r-patchelf-rpath',
			     'content': r_patchelf_rpath },

			   { 'key': 'r-relink-origin',
			     'content': r_relink_origin },

			 ];
